/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {InfiniteScroll} from '../../components'
import WalletDetailListItem from './WalletDetailListItem'
import WalletNoItem from '../../images/wallet/wallet-no-item.png'
import {getJsonFromUrl} from '../../utils'


class WalletDetailList extends React.Component {

    constructor() {
        super();
        this.state = {
            loading: false
        }
    }

    handleLoadMore() {
        this.setState({
            loading: true
        });
        if (getJsonFromUrl().type === 'iap') {
            axios.get('/api/wallet/iap/transaction', {
                params: {
                    filter_scene: this.props.selectType,
                    offset: this.props.walletDetail.next_offset
                }
            }).then(res => {
                if (res.data.code === 0) {
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_APPEND',
                        payload: this.props.walletDetailList.concat(res.data.data.trans)
                    });
                    this.setState({
                        loading: false
                    });
                }
            })
        } else {
            axios.get('/api/wallet/wallet_income_list', {
                params: {
                    filter_scene: this.props.selectType,
                    offset: this.props.walletDetail.next_offset
                }
            }).then(res => {
                if (res.data.code === 0) {
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'WALLET_DETAIL_APPEND',
                        payload: this.props.walletDetailList.concat(res.data.data.liveroom_transaction_list)
                    });
                    this.setState({
                        loading: false
                    });
                }
            })
        }
    }

    renderNoItemText() {
        switch (this.props.selectType) {
            case 'wallet_list':
                return '钱包收益';
            case 'liveroom_income':
                return '店铺收益';
            case 'liveroom_promote_income':
                return '推广收益';
            case 'liveroom_withdraw_list':
                return '提现收益';
            case 'liveroom_other_income':
                return '其它收益';
            case 'share_rebate':
                return '分享收益';
        }
    }

    render() {
        const {walletDetailList, walletDetail} = this.props;

        return (
            <div className="wallet-detail-list">
                {walletDetailList && walletDetailList.length > 0 &&
                <div>
                    <InfiniteScroll
                        onTouchBottom={() => this.handleLoadMore()}
                        isStop={this.state.loading}
                        distance={300}
                        isKill={!walletDetail.has_more}
                    />
                    {walletDetailList.map((item) => <WalletDetailListItem key={item.id} walletListItem={item}/>)}
                </div>
                }
                {walletDetailList && walletDetailList.length === 0 &&
                <div className="wallet-detail-list-none">
                    <img src={WalletNoItem} alt=""/>
                    <p>暂无{this.renderNoItemText()}</p>
                </div>
                }
            </div>
        )
    }
}

export default connect(state => ({
    walletDetail: state.walletDetail.walletDetail,
    walletDetailList: state.walletDetail.walletDetailList,
    selectType: state.walletDetail.selectType
}))(WalletDetailList)



// WEBPACK FOOTER //
// ./src/components/wallet/WalletDetailList.js